const formHelper = {
	el: {
		checkbox: document.querySelectorAll('.js-checkbox'),
		modalContact: document.querySelector('.modal-contacts'),
		body: document.body,
		header: document.querySelector('.header')
	},

	fxFormToJson(el) {
		const indexedArray = {}
		for (let i = 0; i < el.length; i++) {
			if (el[i].value) {
				if ((['checkbox', 'radio'].indexOf(el[i].type) > -1 && el[i].checked) || ['checkbox', 'radio', 'file', 'button'].indexOf(el[i].type) === -1)
					indexedArray[el[i].name] = el[i].value
			}
			else {
				indexedArray[el[i].name] = el[i].name === 'term' ||  el[i].name === 'teacher' ? '' : null
			}
		}
		return indexedArray
	},

	fxInputEvents() {
		this.el.checkbox.forEach(el => el.addEventListener('change', e => e.currentTarget.value = e.currentTarget.checked ? 'true' : 'false'))
	},

	fxShowMessage(form, msg, status = 200) {
		const buttonSubmit = form.el.querySelector('.js-submit')

		buttonSubmit.style.display = 'none'
		form.el.nextElementSibling.textContent = msg
		form.el.nextElementSibling.style.display = 'inherit'

		setTimeout(() => {
			form.el.nextElementSibling.textContent = ''
			form.el.nextElementSibling.style.display = 'none'
			buttonSubmit.removeAttribute('disabled')
			buttonSubmit.style.display = 'inherit'
			status === 200 ? form.el.reset() : ''
			if (document.querySelector('[type="file"]')) {
				form.el.value = ''
				form.el.querySelector('[name="fileName"]').value = ''
				form.el.querySelector('.upload-file__name').textContent = ''
				setTimeout(() => form.el.querySelector('.js-clear-file').style.display = 'none', 0)
			}
		}, 5000)
	},

	fxShowModalSubmitMessage () {
		const sucessMessage = this.el.modalContact.querySelector('.umbraco-forms-submitmessage')
		if(!sucessMessage) return
		this.fxModalContactsOpen()
	},

	fxValidateModal () {
		const form = this.el.modalContact.querySelector('form')
		if(!form) return
		const error = form.querySelectorAll('.field-validation-error')
		if([...error].length) {
			this.fxModalContactsOpen()
		}
	},

	fxModalContactsOpen () {
		this.el.modalContact.classList.add('is-modal-open')
		this.el.body.classList.add('no-scroll-hidden')
		setTimeout(() => {
			this.el.header.classList.add('header--modal')
			this.el.header.classList.contains('header--fixed') && this.el.header.classList.remove('header--fixed')
		}, 500)
	},

	init() {
		this.fxInputEvents()

		if(!this.el.modalContact) return
		this.fxShowModalSubmitMessage()
		this.fxValidateModal()
	}
}

formHelper.init()